import { Link } from 'react-router-dom';
import { mangas } from '@/mocks/manga';

export default function RecommendSection() {
  const main = mangas.find((m) => m.id === 'm1')!;
  const picks = mangas.filter((m) => m.id === 'm4' || m.id === 'm6');

  return (
    <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16" aria-label="编辑推荐">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <span className="text-xs font-medium uppercase tracking-widest text-primary-600">
            Recommended
          </span>
          <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-3xl">编辑精选书单</h2>
        </div>
        <Link
          to="/category"
          className="flex items-center gap-1 whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
        >
          更多推荐
          <i className="ri-arrow-right-line" aria-hidden="true" />
        </Link>
      </div>

      <div className="mt-6 grid grid-cols-1 gap-4 lg:grid-cols-3">
        <Link
          to={`/manga/${main.id}`}
          className="group relative overflow-hidden rounded-lg lg:col-span-2"
        >
          <img
            src={main.cover}
            alt={`${main.title}漫画编辑推荐`}
            title={`${main.title}漫画免费阅读`}
            className="h-64 w-full object-cover object-top transition-transform duration-700 group-hover:scale-105 md:h-80"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/30 to-transparent" />
          <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs text-background-50">
              <i className="ri-fire-fill" aria-hidden="true" />
              全站力荐
            </span>
            <h3 className="mt-3 font-heading text-xl text-background-50 md:text-2xl">
              《{main.title}》漫画
            </h3>
            <p className="mt-2 line-clamp-2 max-w-2xl text-sm text-background-50/85">
              {main.description}
            </p>
            <span className="mt-4 inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/40 bg-background-50/10 px-4 py-2 text-sm text-background-50 backdrop-blur transition-colors group-hover:bg-primary-500">
              立即免费阅读
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </span>
          </div>
        </Link>

        <div className="flex flex-col gap-4">
          {picks.map((manga) => (
            <Link
              key={manga.id}
              to={`/manga/${manga.id}`}
              className="group flex flex-1 items-center gap-4 rounded-lg bg-secondary-100 p-4 transition-all hover:bg-secondary-200/70"
            >
              <span className="relative h-28 w-20 shrink-0 overflow-hidden rounded-md bg-background-50">
                <img
                  src={manga.cover}
                  alt={`${manga.title}漫画推荐`}
                  title={`${manga.title}漫画免费阅读`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </span>
              <span className="min-w-0 flex-1">
                <h3 className="truncate text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-700 md:text-base">
                  《{manga.title}》
                </h3>
                <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-700">
                  {manga.description}
                </p>
                <span className="mt-2 inline-flex items-center gap-1 text-xs font-medium text-primary-700">
                  立即阅读
                  <i className="ri-arrow-right-line" aria-hidden="true" />
                </span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}